import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { DOCUMENT_PRIVILEGE, } from './auth-info-entity.interface';
import AuthRepository from '../repository/auth-repository';
import { DocAuthExpTime } from '../value-object/doc-auth-exp-time';
import { dataFieldNamingHandler, exceptionHandler } from '../../base/decorators';
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { safeParseObject } from '../../base/utils';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { AUTH_ROLE } from '@tencent/ark-service-interface';
import { Emitter } from '@tencent/ark-utils/lib/event';
import { ServerMessageNoticeEventType } from '@tencent/docs-connection';
import { DocAdvancedPrivilege } from '../value-object/doc-advanced-privilege';
import { DocPrivilege } from '../value-object/doc-privilege';
/**
 * 当前账户拥有的文档权限
 */
var AuthInfoEntity = /** @class */ (function () {
    function AuthInfoEntity(docMetaDomainService, networkRequestService) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequestService = networkRequestService;
        this.selfRole = AUTH_ROLE.noPrivilege;
        this.isOwner = false;
        this.isAdmin = false;
        this.selfDocPrivilege = new DocPrivilege({});
        this.selfDocAdvancedPrivilege = new DocAdvancedPrivilege({});
        this.documentPrivilege = DOCUMENT_PRIVILEGE.deny;
        this.memberList = [];
        this.onAuthChangedEmitter = new Emitter();
        this.onAuthExpTimeChangedEmitter = new Emitter();
        this.onSelfPrivilegeChangedEmitter = new Emitter();
        this.authRepository = new AuthRepository(docMetaDomainService, networkRequestService);
        // 初始化事件监听器
        this.onAuthChanged = this.onAuthChangedEmitter.event;
        this.onAuthExpTimeChanged = this.onAuthExpTimeChangedEmitter.event;
        this.onSelfPrivilegeChanged = this.onSelfPrivilegeChangedEmitter.event;
    }
    AuthInfoEntity.prototype.fetchAuthExpTime = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.authRepository.fetchAuthExpTime()];
            });
        });
    };
    AuthInfoEntity.prototype.changeAuthExpTime = function (expTime) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.authRepository.changeAuthExpTime(expTime)];
            });
        });
    };
    AuthInfoEntity.prototype.fetchAuthInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.authRepository.fetchAuthInfo()];
            });
        });
    };
    AuthInfoEntity.prototype.changeAuthInfo = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.authRepository.changeAuthInfo(options)];
            });
        });
    };
    AuthInfoEntity.prototype.fetchAuthInfoData = function (docId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.authRepository.fetchAuthInfoData(docId)];
            });
        });
    };
    AuthInfoEntity.prototype.fetchFolderAuth = function (folderId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.authRepository.fetchFolderAuth(folderId)];
            });
        });
    };
    AuthInfoEntity.prototype.changeFolderAuth = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.authRepository.changeFolderAuth(options)];
            });
        });
    };
    AuthInfoEntity.prototype.fetchAuthConfig = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.authRepository.fetchAuthConfig()];
            });
        });
    };
    /**
     * 收到服务端Socket事件
     */
    AuthInfoEntity.prototype.onReceiveMessageFromServer = function (data, channel) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.notifyRightChange(data)];
                    case 1:
                        _a.sent();
                        this.checkSelfPrivilege(channel);
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthInfoEntity.prototype.handleForDifferentActions = function (msgFilterData) {
        return __awaiter(this, void 0, void 0, function () {
            var seq, tempMsgFilterData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        seq = msgFilterData.seq;
                        if (!(msgFilterData.action === 1)) return [3 /*break*/, 4];
                        if (!msgFilterData) return [3 /*break*/, 3];
                        tempMsgFilterData = msgFilterData;
                        if (!(tempMsgFilterData[seq] === undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.handleAuthChange()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        delete tempMsgFilterData[seq];
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        if (msgFilterData.action === 2) {
                            // 目前action均为1，此处预留
                        }
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 收到权限变更通知后，重新拉取最新的权限信息
     */
    AuthInfoEntity.prototype.handleAuthChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, info;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isOwner || !this.isAdmin)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.fetchAuthInfo()];
                    case 1:
                        res = _a.sent();
                        if (res.resData.cgicode === 0 && res.resData.retcode === 0) {
                            info = res.resData.data;
                            this.documentPrivilege = info.policy;
                            this.memberList = info.memberList;
                            this.onAuthChangedEmitter.fire({
                                newDocumentPrivilege: this.documentPrivilege,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthInfoEntity.prototype.handleExpInfoChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resData, _a, setTime, remainTime, expTime, startTime, info;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.fetchAuthExpTime()];
                    case 1:
                        resData = (_b.sent()).resData;
                        _a = (resData === null || resData === void 0 ? void 0 : resData.data) || {}, setTime = _a.settime, remainTime = _a.remaintime, expTime = _a.exptime, startTime = _a.starttime;
                        if (setTime && setTime > 0) {
                            info = new DocAuthExpTime({
                                expTime: expTime,
                                remainTime: remainTime,
                                setTime: setTime,
                                startTime: startTime,
                            });
                            this.onAuthExpTimeChangedEmitter.fire({
                                newExpTime: info,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthInfoEntity.prototype.checkExpTimeParams = function (msgFilterData) {
        return msgFilterData.exptime !== 'undefined' && msgFilterData.settime !== 'undefined' && msgFilterData.starttime !== 'undefined';
    };
    AuthInfoEntity.prototype.checkSelfPrivilege = function (channel) {
        var _this = this;
        // 目前版本 @tencent/docs-connection 库不提供 sendMessage 方法，升级后去掉 as any 即可
        channel.sendMessage({
            cmd: 'GET_PRIVILEGE',
            taskId: void 0,
            data: JSON.stringify({}),
            onsend: function (seq, cmd, data, result) {
                if (_this.checkGetPrivilegeResult(result)) {
                    var newPrivilegeAttribute = result.response.onpost.privilege_attribute;
                    /**
                     * 这里早期接口定义的时候，privilege_attribute外层是0和1，privilege_attribute.docx_attribute是true/false
                     * 后面也很难改了，考虑到调用方可能一直用0和1去判断
                     * 故此这里只能继续取外层的数据更新，导致现在ark吐出的数据有0和1，也有true/false。
                     */
                    if (_this.checkDocPrivilegeChange(newPrivilegeAttribute)) {
                        _this.selfDocPrivilege.canEdit = newPrivilegeAttribute.can_edit;
                        _this.selfDocPrivilege.canRead = newPrivilegeAttribute.can_read;
                        _this.selfDocPrivilege.canComment = newPrivilegeAttribute.can_comment;
                        _this.selfDocPrivilege.canCopy = newPrivilegeAttribute.can_copy;
                        _this.selfDocPrivilege.canEditTitle = newPrivilegeAttribute.can_edit_title;
                        _this.onSelfPrivilegeChangedEmitter.fire({
                            newSelfPrivilege: _this.selfDocPrivilege,
                        });
                    }
                }
            },
            onError: function () {
                //
            },
        });
    };
    AuthInfoEntity.prototype.checkGetPrivilegeResult = function (result) {
        var _a, _b;
        return result.errCode === 0 && ((_b = (_a = result.response) === null || _a === void 0 ? void 0 : _a.onpost) === null || _b === void 0 ? void 0 : _b.result) === 0;
    };
    AuthInfoEntity.prototype.checkDocPrivilegeChange = function (newPrivilegeAttribute) {
        return this.selfDocPrivilege.canEdit !== newPrivilegeAttribute.can_edit
            || this.selfDocPrivilege.canRead !== newPrivilegeAttribute.can_read
            || this.selfDocPrivilege.canComment !== newPrivilegeAttribute.can_comment
            || this.selfDocPrivilege.canCopy !== newPrivilegeAttribute.can_copy
            || this.selfDocPrivilege.canEditTitle !== newPrivilegeAttribute.can_edit_title;
    };
    AuthInfoEntity.prototype.notifyRightChange = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var msgFilterData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(data.type === ServerMessageNoticeEventType.EXPIRED_TIME_CHANGE)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.handleExpInfoChange()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                    case 2:
                        if (!(data && (data.payload === '' || data.payload === null))) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.handleAuthChange()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                    case 4:
                        msgFilterData = safeParseObject(decodeURIComponent(data.payload), decodeURIComponent(data.payload));
                        if (msgFilterData === null) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.handleForDifferentActions(msgFilterData)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AuthInfoEntity.prototype, "fetchAuthExpTime", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], AuthInfoEntity.prototype, "changeAuthExpTime", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AuthInfoEntity.prototype, "fetchAuthInfo", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuthInfoEntity.prototype, "changeAuthInfo", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], AuthInfoEntity.prototype, "fetchAuthInfoData", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], AuthInfoEntity.prototype, "fetchFolderAuth", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Promise)
    ], AuthInfoEntity.prototype, "changeFolderAuth", null);
    __decorate([
        dataFieldNamingHandler(),
        exceptionHandler(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], AuthInfoEntity.prototype, "fetchAuthConfig", null);
    AuthInfoEntity = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __metadata("design:paramtypes", [Object, Object])
    ], AuthInfoEntity);
    return AuthInfoEntity;
}());
export default AuthInfoEntity;
